import { createContext } from "react";

const DriverTransactionScreen = createContext<any>(null);

export default DriverTransactionScreen;
